import {Moment} from "moment-timezone";

export abstract class FieldModel<V> {
    name:string;
    label:string;
    type:FieldType;
    required: boolean = false;
    value: V;
    defaultValue: V;

    protected constructor(name: string, label: string, type: FieldType, required?:boolean, value?:V, defaultValue?:V) {
        this.name = name;
        this.label = label;
        this.type = type;
        this.required = required;
        this.value = value;
        this.defaultValue = defaultValue;
    }
}

export enum FieldType {
    TEXT = 'TEXT',
    NUMERIC = 'NUMERIC',
    CHOICE = 'CHOICE',
    AMOUNT = 'AMOUNT',
    DATE = 'DATE',
    DATETIME = 'DATETIME',
    YES_NO = 'YES_NO',
}


export class TextFieldModel extends FieldModel<string>{
    constructor(name: string, label: string, required?:boolean, value?:string) {
        super(name, label, FieldType.TEXT, required, value);
    }
}

export class YesNoFieldModel extends FieldModel<boolean>{
    constructor(name: string, label: string, required?:boolean, value?:boolean, defaultValue?:boolean) {
        super(name, label, FieldType.YES_NO, required, value, defaultValue);
    }
}

export abstract class NumberFieldModel extends FieldModel<number>{
    decimalDigits:number;
    acceptNegative:boolean = false;
    constructor(name: string, label: string, type: FieldType, decimalDigits: number, acceptNegative:boolean, required?:boolean, value?:number, defaultValue?:number) {
        super(name, label, type, required, value, defaultValue);
        this.decimalDigits = decimalDigits;
        this.acceptNegative = acceptNegative;
    }
}

export class NumericFieldModel extends NumberFieldModel{
    constructor(name: string, label: string, decimalDigits: number, acceptNegative:boolean, required?:boolean, value?:number) {
        super(name, label, FieldType.NUMERIC, decimalDigits, acceptNegative, required, value);
    }
}

export abstract class ChoiceFieldModel<V> extends FieldModel<V>{
    displayOnSelect:boolean = false;
    multipleChoice:boolean;
    protected constructor(name: string, label: string, multipleChoice:boolean, displayOnSelect?:boolean, required?:boolean) {
        super(name, label, FieldType.CHOICE, required);
        this.multipleChoice = multipleChoice;
        this.displayOnSelect = displayOnSelect;
    }
}

export class SingleChoiceFieldModel<V> extends ChoiceFieldModel<V>{
    allValues:V[];
    constructor(name: string, label: string, displayOnSelect?:boolean, required?:boolean) {
        super(name, label, false, displayOnSelect, required);
    }
}

export class MultipleChoiceFieldModel<V> extends ChoiceFieldModel<V[]>{
    allValues:V[];
    constructor(name: string, label: string, displayOnSelect?:boolean, required?:boolean) {
        super(name, label, true, displayOnSelect, required);
    }
}

export class AmountFieldModel extends NumberFieldModel{
    constructor(name: string, label: string, decimalDigits: number, acceptNegative:boolean, required?:boolean, value?:number) {
        super(name, label, FieldType.AMOUNT, decimalDigits, acceptNegative, required, value);
    }
}

export class DateFieldModel extends FieldModel<Moment>{
    constructor(name: string, label: string, required?:boolean, value?:Moment) {
        super(name, label, FieldType.DATE, required, value);
    }
}

export class DateTimeFieldModel extends FieldModel<Moment>{
    constructor(name: string, label: string, required?:boolean, value?:Moment) {
        super(name, label, FieldType.DATETIME, required, value);
    }
}